import { isEmpty } from 'lodash';
import React, { useContext } from 'react';
import FormButtons from '../common/form/FormButtons';
import { FormContext } from '../common/form/FormContext';

type AttributeEditorButtonsProps = {
    onSave: (value) => void;
    onCancel: () => void;
    saveButtonLabel?: string;
};

export default function AttributeEditorButtons({ onCancel, saveButtonLabel, onSave }: AttributeEditorButtonsProps) {
    const { state, setState, validation } = useContext(FormContext);

    return (
        <FormButtons
            containerSx={{
                pr: 2,
                pb: 2,
                position: 'sticky',
                bottom: 0,
                backgroundColor: 'background.paper',
                zIndex: 4
            }}
            onClickCancel={() => {
                setState(undefined);
                onCancel();
            }}
            onClickSave={() => {
                onSave(state);
                setState(undefined);
            }}
            disableSave={isEmpty(validation?.modified)}
            saveButtonLabel={saveButtonLabel}
        />
    );
}
